import React from 'react';
import styled from 'styled-components';

import { ServiceProvider } from '@/modules/Service/ServiceProvider';

import Hero from './components/Hero';
import Services from './components/Services';
import Dealers from './components/Dealers';
import About from './components/About';

export function ServiceBrandService() {
  return (
    <ServiceProvider>
      <Component>
        <Hero />
        <About />
        <Services />
        <Dealers />
      </Component>
    </ServiceProvider>
  );
}

const Component = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
`;
